import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { api } from 'lib/axios'
import { getUserId } from 'lib/auth/tokenStorage'
import { setUpdatedDoc } from 'slices/customerFiles'

const processAllFiles = async (data, onUploadProgress) => {
  const { file, agent_id, contact_id } = data

  const formData = new FormData()
  formData.append('images[]', file)
  formData.append('contact_id', contact_id)
  formData.append('agent_id', agent_id)
  const response = await api.post(
    '/Api/V8/custom/customer/process-all-files',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      timeout: 600000, // 10 min
      onUploadProgress
    }
  )
  return response.data
}

export const useProcessAllFiles = () => {
  const dispatch = useDispatch()
  const [isUploading, setIsUploading] = useState(false)

  const handleProcessAllFiles = async (file, id, customerId) => {
    setIsUploading(true)
    try {
      const agentId = getUserId()

      const response = await processAllFiles(
        {
          file,
          agent_id: agentId,
          contact_id: customerId
        },
        progressEvent => {
          let percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          )
          dispatch(
            setUpdatedDoc({
              id,
              data: {
                status:
                  percentCompleted >= 100
                    ? 'Processing...'
                    : 'Uploading File...',
                progress: percentCompleted,
                isUploaded: true,
                isError: false
              }
            })
          )
        }
      )

      return response
    } catch (error) {
      let errStatus = ''
      if (error.message === 'Network Error' || error.code === 'ERR_NETWORK') {
        errStatus = 'Network error. Please check your connection and retry.'
      } else if (error.message?.includes?.('ERR_CONNECTION_REFUSED')) {
        errStatus = 'Server unavailable, Connection refused'
      } else if (error.response?.status === 401) {
        errStatus = 'Session expired. Please log in again and retry the upload.'
      } else {
        errStatus = 'Uploading error.'
      }

      dispatch(
        setUpdatedDoc({
          id,
          data: {
            status: errStatus || 'Uploading error',
            isUploaded: false,
            isError: true
          }
        })
      )

      throw error
    } finally {
      setIsUploading(false)
    }
  }

  return { handleProcessAllFiles, isUploading }
}
